import { useContext } from "react";
import { AuthContext } from "../../../context/AuthProvider";
import { Navigate, useLocation } from "react-router-dom";
import useAdmin from "../../../hooks/useAdmin";
import Looading from "../../../pages/Shared/Looading/Looading";

const AdminRoute = ({ children }) => {

    const { user, loading } = useContext(AuthContext)
    const [isAdmin,isAdminLoading] = useAdmin(user.email)

    const location = useLocation()

    if (loading || isAdminLoading) {

        return <Looading></Looading>
    }

    if (user && isAdmin) {

        return children;

    }


    return <Navigate to='/login' state={{ from: location }} replace></Navigate>

};

export default AdminRoute;